import React from 'react'
import { Text } from 'styles/reactnative'
import { Tag } from 'antd'
import UserTag from '../../../components/UserTag'
import EntryTime from '../../../components/PositionColumns/EntryTime'
import MemoInput from '../WithdrawalManagement/MemoInput'
import { TagWrap } from '../../../components/AdminUserModal/UserInfoTabs/styles'
import { COLORS } from '../../../constants'

export const AdminDepositTableColumn: any = (mutate, openModal) => {
	return [
		{
			title: '번호',
			dataIndex: 'id',
			align: 'center',
			width: 100,
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '생성일',
			dataIndex: 'created_at',
			align: 'center',
			width: 130,
			render: (text, data) => <EntryTime time={text} />,
		},
		{
			title: '승인일',
			dataIndex: 'confirm_at',
			width: 130,
			align: 'center',
			render: (text, data) => {
				{
					return text ? <EntryTime time={text} /> : <Text>-</Text>
				}
			},
		},
		{
			title: '회원',
			dataIndex: 'user_id',
			width: 150,
			align: 'center',
			render: (text, data) => (
				<UserTag
					userid={text}
					email={data?.email}
					phone={data?.phone}
					nickname={data?.fullname || data?.nickname}
					onClick={() => {
						openModal(text)
					}}
				/>
			),
		},
		{
			title: '진행',
			dataIndex: 'process',
			width: 70,
			align: 'center',
			render: (text, data) => (
				<TagWrap>
					{text == 1 ? (
						<Tag style={{ backgroundColor: 'white' }}>
							입금감지중
						</Tag>
					) : text == 2 ? (
						<Tag
							style={{
								backgroundColor: COLORS.lightGreen,
								color: 'white',
							}}>
							완료
						</Tag>
					) : text == 3 ? (
						<Tag>검토중</Tag>
					) : text == 4 ? (
						<Tag>거절됨</Tag>
					) : (
						<Tag>취소</Tag>
					)}
				</TagWrap>
			),
		},
		{
			title: '코인',
			align: 'center',
			width: 60,
			dataIndex: 'symbol',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '네트워크',
			align: 'center',
			width: 80,
			dataIndex: 'network',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '지갑주소',
			align: 'center',
			dataIndex: 'wallet_address',
			render: (text, data) => (
				<Text style={{ justifyContent: 'flex-start' }}>{text}</Text>
			),
		},
		{
			title: 'TXID',
			dataIndex: 'txid',
			align: 'center',
			render: (text, data) => <Text style={{fontSize:12}}>{text}</Text>,
		},
		{
			title: '지갑잔액',
			dataIndex: 'balance',
			align: 'center',
			width: 100,
			render: (text, data) => <Text>{text || 0}</Text>,
		},
		{
			title: '입금수량',
			dataIndex: 'amount',
			align: 'center',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '관리메모',
			align: 'center',
			dataIndex: 'memo',
			render: (text, data) => (
				<MemoInput data={data} type={'D'} mutate={mutate} />
			),
		},
	]
}
